export default {
    data() {
        return {
            delay: 500, // time in miliseconds
            timeoutRef: null,
            windowEl: null,
            stateEl: null,
            winFn: () => {}
        }
    },
    methods: {
        /**
         * MAIN FUNCTION TO ACTIVE HIDE A WINDOW
         * @param stateEl
         * @param winEl
         * @param fn
         */
        activateWindow(stateEl, winEl, fn) {
            this.stateEl = stateEl;
            this.windowEl = winEl;
            this.winFn = fn;
            this.stateEl.addEventListener('mouseleave', this._handleStateElMouseLeave);
        },
        /**
         * @param delay
         */
        setDelay(delay) {
            this.delay = delay;
        },
        _handleStateElMouseLeave() {
            this.timeoutRef = setTimeout(this._handleHideWindow, this.delay);
            this.windowEl.addEventListener('mouseenter', this._handleMouseEnter);
            this.stateEl.removeEventListener('mouseleave', this._handleStateElMouseLeave);
        },
        _handleMouseEnter() {
            this._clearTimeout();
            this._removeMouseEnter();
            this.windowEl.addEventListener('mouseleave', this._handleMouseLeave);
        },
        _handleMouseLeave() {
            this._handleHideWindow();
        },
        _handleHideWindow() {
            this.winFn();
            this._removeMouseEnter();
            this._removeMouseLeave();
        },
        _removeMouseEnter() {
            this.windowEl.removeEventListener('mouseenter', this._handleMouseEnter);
        },
        _removeMouseLeave() {
            this.windowEl.removeEventListener('mouseleave', this._handleMouseEnter);
        },
        _clearTimeout() {
            if (this.timeoutRef) clearTimeout(this.timeoutRef);
        }
    },

    beforeDestroy() {
        // clear events installed
        this._removeMouseEnter();
        this._removeMouseLeave();
        this.stateEl.addEventListener('mouseleave', this._handleStateElMouseLeave);
    }
}
